import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
export const getCourseDetails = createAsyncThunk(
  "get/courseDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("courseDetails", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const getQA = createAsyncThunk(
  "get/QA",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("qaList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const replyToQA = createAsyncThunk(
  "post/QA",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("replyToQa", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const getVideoforChapter = createAsyncThunk(
  "get/video",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("chapterVideosOfChapter", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const replyToRating = createAsyncThunk(
  "get/video",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addRating", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
const courseDetailsManagement = createSlice({
  name: "CourseDetails",
  initialState: {
    courseDetails: [],
    QA: [],
    video: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getCourseDetails.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getCourseDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.courseDetails = action.payload;
    });
    builder.addCase(getQA.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getQA.fulfilled, (state, action) => {
      state.loading = false;
      state.QA = action.payload;
    });
    builder.addCase(getVideoforChapter.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getVideoforChapter.fulfilled, (state, action) => {
      state.loading = false;
      state.video = action.payload;
    });
  },
});

export default courseDetailsManagement.reducer;
